import React, { createContext, useState, useContext, ReactNode } from 'react';

type NavLink = {
  to: string;
  label: string;
  icon?: string;
  activeIcon?: string;
};

type NavLinksSet = {
  links: NavLink[];
  title?: string;
};

interface NavLinksContextType {
  currentNavLinks: NavLinksSet;
  setNavLinks: (navLinks: NavLinksSet) => void;
}

const NavLinksContext = createContext<NavLinksContextType | undefined>(undefined);

interface NavLinksProviderProps {
  children: ReactNode;
  defaultLinks?: NavLinksSet;
}

const DEFAULT_NAV_LINKS: NavLinksSet = {
  links: [
    { to: '/dashboard', label: 'Dashboard' },
    { to: '/records', label: 'Records' },
  ],
};

export const NavLinksProvider: React.FC<NavLinksProviderProps> = ({ 
  children, 
  defaultLinks = DEFAULT_NAV_LINKS 
}) => {
  const [currentNavLinks, setCurrentNavLinks] = useState<NavLinksSet>(defaultLinks);

  return (
    <NavLinksContext.Provider value={{ currentNavLinks, setNavLinks: setCurrentNavLinks }}>
      {children}
    </NavLinksContext.Provider>
  );
};

export const useNavLinksContext = (): NavLinksContextType => {
  const context = useContext(NavLinksContext);
  if (context === undefined) {
    throw new Error('useNavLinksContext must be used within a NavLinksProvider');
  }
  return context;
};

export type { NavLink, NavLinksSet };